
<template>
  <m-layout>
    <div style="width:100%; height: 100%; position:relative">

      <m-campaigner-user-add ref="addlist"></m-campaigner-user-add>
      <m-carecenter-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-carecenter-form>
      <m-carecenter-edit-form :form="form" :carecenter="selectedItem" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-carecenter-edit-form>
         <v-toolbar extended>



      <v-toolbar-title>Campaign</v-toolbar-title>

      <div class="flex-grow-1"></div>

          <v-tabs
            icons-and-text
            v-model="tabsmodel"
            slider-color="primary"
            background-color="transparent"
          >

          <v-tabs-slider></v-tabs-slider>


            <v-tab v-for="(tab, i) in tabs" :href="'#' + tab.text"
            @click="onTab(tab)"
            :key="i">
              {{ tab.text }}
              <v-icon >{{ tab.icon }}</v-icon>
            </v-tab>
          </v-tabs>


        </v-toolbar>




        <v-tabs-items  v-model="tabsmodel" class="elevation-0">
          <v-tab-item flat
            value="reports"
            style=" height: 100%;"
          >

            <v-layout wrap justify-center class="pt-3" style="height: 100%; width:100%;">
              <div class="align-center" style="">reports</div>
            </v-layout>

          </v-tab-item>


         <v-tab-item flat
            value="lists"
            style=" height: 100%;"
          >
            <v-layout wrap justify-center class="pt-3" style="height: 100%; width:100%;">
              <v-flex  v-show="current === 'lists'" xs12 class="align-center" style="">
                <div style="position: relative; width: 100%; height: 100%">
                <v-btn
                absolute
                  dark
                  fab
                  right
                  color="primary"
                  @click.native.stop="dialog = true">
                  <v-icon>add</v-icon>
                </v-btn>

                <v-data-table
                    v-bind:headers="headers"
                    v-bind:items="items"
                    v-bind:search="search"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 30, 40, {text:'All', value:-1}]
                    }"
                  >

                <template v-slot:body="{ items }">
                  <tbody>
                  <tr v-for="item in items" :key="item.name" :class="{'subscribed' :  (item.subscribed_id)}">
                    <td >{{ item.id }}</td>
                    <td >{{ item.name }}</td>
                    <td >{{ item.email_address }}</td>
                    <td >{{ item.tel }}</td>
                    <td >{{ item.fullAddress }}</td>
                    <td >{{ (item.visited === 1) ? 'yes' : '' }}</td>
                    <td >{{ (item.marked === 1) ? 'yes' : '' }}</td>
                    <td style="text-align: center">

<!--                  <span v-if="(item.subscribed_id)">
                        <v-icon>check</v-icon>
                      </span> -->
                      <v-btn v-if="(item.subscribed_id)" icon class="mx-0" @click="unsubscribe(item)">
                        <v-icon color="primary">remove</v-icon>
                      </v-btn>
                      <v-btn v-else icon class="mx-0" @click="subscribe(item)">
                        <v-icon color="primary">add</v-icon>
                      </v-btn>
                    </td>
                    <td class="justify-center layout px-0">

                      <v-btn icon class="mx-0" @click="editItem(item)">
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="deleteItem(item.id)">
                        <v-icon color="primary">delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>

              <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                From {{ pageStart }} to {{ pageStop }}
              </template>

                </v-data-table>
</div>
                </v-flex>;
            </v-layout>
          </v-tab-item>


         <v-tab-item flat
            value="campaigns"
            style=" height: 100%;"
          >
            <v-layout wrap justify-center class="pt-3" style="height: 100%; width:100%;">
              <v-flex  xs12 class="align-center" style="">
                <v-list three-line>
                <template v-for="(item, index) in data.campaigns">
                  <v-list-item :key="index">
                    <v-list-item-avatar>
                      <v-icon v-if="item.status === 'sent'">send</v-icon>
                      <v-icon v-else>wait</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="item.settings.title"></v-list-item-title>
                      <v-list-item-subtitle v-html="item.recipients.list_name"></v-list-item-subtitle>
                      <v-list-item-subtitle>List: {{ item.recipients.list_name }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="item.settings.title"></v-divider>
                </template>
              </v-list>

                </v-flex>
            </v-layout>
          </v-tab-item>
         <v-tab-item flat
            value="templates"
            style=" height: 100%;"
          >
            <v-layout wrap justify-center class="pt-3" style="height: 100%; width:100%;">
              <v-flex  xs12 class="pt-3 align-center" style="text-align: center">
                <m-thumbs :items="data.templates" :class="{'show': show}"></m-thumbs>
                </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>


    </div>
  </m-layout>
</template>
<script>
import CareCenterMixin from '@/mixins/carecenter';
import TemplatesThumbs from '@/components/campaigner/templates-thumbs';
export default {
  mixins: [CareCenterMixin],
  components: {
    'm-thumbs': TemplatesThumbs
  },
  data () {
    return {
      tabs: [
        {text: 'reports', icon: 'equalizer'},
        {text: 'lists', icon: 'group_add'},
        {text: 'campaigns', icon: 'message'},
        {text: 'templates', icon: 'list_alt'}
      ],
      tabsmodel: null,
      data: [],
      show: false,
      current: 'reports'
    };
  },
  methods: {
    inValidItem (item) {
      return !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(item.email_address));
    },
    eventClick: function () {
      // this.getLists();
      this.getData('templates');
    },
    onTab (w) {
      console.log(w)
      this.current = w.text;
      if (w.text === 'lists') {
        if (!this.items.length) {
          this.getDataCenters();
        }
      } else {
        this.getData(w.text);
      }
    },
    getData (what, id) {
      var app = this;
      app.show = false;
      if (!app.data[what]) {
        app.getMailChimpData(what, id).then((result) => {
          app.data[what] = result;
          app.$nextTick(() => { app.show = true });
        })
      }
    }
  }
};
</script>
<style lang="scss">
.item {
  color:rgba(248, 1, 1, 1);
  &.subscribed {
    text-transform: none;
    color: rgb(44, 44, 44);
  }
}
</style>
